<template>
    <div class="pageinfo">
        <img src="@/assets/images/show.png" width="90%" style="margin:20% auto 0;display: block;" />
        <p class="message">{{ msg }}</p>
        <van-button round type="info" block @click="goHome">返回首页</van-button>
        <van-button round type="info" @click="goBackHandle" block plain>返回个人中心</van-button>
    </div>
</template>


<script>
// let wx = window.wx;
export default {
    props: {
        msg: {
            type: String,
            default: "操作完成，报告审核中！"
        }
    },
    methods: {
        // callback() {
        //     wx.miniProgram.navigateBack();
        // },
        goBackHandle() {
            // wx.miniProgram.switchTab({ url: '/pages/usercenter/index' })
            this.$router.push("/credit/account");
        },
        goHome() {
            // wx.miniProgram.switchTab({ url: '/pages/home/index' })
            this.$router.push("/credit/home");
        },
        // navigateTo() {
        //     wx.miniProgram.navigateTo({ url: "/pages/usercenter/index" })
        // }
    }
}
</script>

<style scoped>
.pageinfo {
    padding: 20px;
}

.message {
    color: #333;
    font-size: 14px;
    margin-top: 20px;
    text-align: center;
}

.pageinfo .van-button {
    margin-top: 20px;
}
</style>